import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ConnectionBanner } from './ConnectionBanner';
import { GlobalOverrideBanner } from './GlobalOverrideBanner';

// 권위: docs/ARCH_DASHBOARD.md §4.0 (레이아웃), §6.1.2 (구조), §3.1 (컴포넌트 맵)
// 데스크톱: CSS Grid header(56px) / sidebar(232px) / main.
// 모바일(<=900px): sidebar 가 off-canvas drawer 로 전환, 햄버거로 토글.
export function AppShell(): JSX.Element {
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const closeMenu = useCallback(() => setMenuOpen(false), []);
  const toggleMenu = useCallback(() => setMenuOpen((v) => !v), []);

  // 페이지 이동 시 drawer 자동 닫기.
  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  // Esc 키로 drawer 닫기. body 스크롤 잠금.
  useEffect(() => {
    if (!menuOpen) return;
    function onKey(e: KeyboardEvent): void {
      if (e.key === 'Escape') setMenuOpen(false);
    }
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [menuOpen]);

  return (
    <div className={`app-shell${menuOpen ? ' app-shell--menu-open' : ''}`}>
      <Header onMenuToggle={toggleMenu} menuOpen={menuOpen} />
      <Sidebar open={menuOpen} />
      {/* 모바일 drawer 오버레이 — 바깥 클릭으로 닫힘. */}
      {menuOpen && (
        <button
          type="button"
          className="app-shell__backdrop"
          aria-label="메뉴 닫기"
          onClick={closeMenu}
        />
      )}
      <main className="app-shell__main">
        {/*
          Override 배너는 Header 바로 아래, Outlet 위에 고정.
          active 가 없으면 null 반환 — 레이아웃 영향 없음.
        */}
        <GlobalOverrideBanner />
        <ConnectionBanner />
        <Outlet />
      </main>
    </div>
  );
}
